module.exports = __webpack_public_path__ + "static/img/translation24.b8438fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/result/24/translation24.png
// module id = cVFj
// module chunks = 0